import ResourceAdmin from "@/components/admin/ResourceAdmin";
import { absoluteUrl, adminEndpoints } from "@/lib/adminApi";

const emptyItem = {
  title_ar: "", description_ar: "", image: "",
  location_ar: "", date_ar: "", service_slug: null,
  order: 0, is_active: true,
};

export default function ProjectsAdmin() {
  return (
    <ResourceAdmin
      title="المشاريع"
      resource="projects"
      testIdPrefix="admin-projects"
      emptyItem={emptyItem}
      loadExtra={async () => ({
        services: await adminEndpoints.crud("services").list(),
      })}
      columns={[
        {
          key: "image", label: "الصورة",
          render: (r) => r.image ? <img src={absoluteUrl(r.image)} alt="" className="w-12 h-12 rounded-lg object-cover" /> : <div className="w-12 h-12 rounded-lg bg-slate-100" />,
        },
        { key: "title_ar", label: "الاسم" },
        { key: "location_ar", label: "الموقع" },
        { key: "date_ar", label: "التاريخ" },
        {
          key: "is_active", label: "الحالة",
          render: (r) => (
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${r.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>
              {r.is_active ? "مفعّل" : "معطّل"}
            </span>
          ),
        },
      ]}
      fields={[
        { name: "title_ar", label: "اسم المشروع", type: "text" },
        { name: "description_ar", label: "الوصف", type: "textarea", rows: 3 },
        { name: "image", label: "صورة المشروع", type: "image" },
        { name: "location_ar", label: "الموقع (المدينة)", type: "text" },
        { name: "date_ar", label: "السنة/التاريخ", type: "text" },
        {
          name: "service_slug", label: "الخدمة المرتبطة", type: "select",
          options: (extra) => (extra?.services || []).map((s) => ({ value: s.slug, label: s.title_ar })),
        },
        { name: "order", label: "الترتيب", type: "number", min: 0 },
        { name: "is_active", label: "مفعّل", type: "checkbox" },
      ]}
    />
  );
}
